import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Like react-router's <Link>, but for routes that need an account. If the
 * user is logged out at click time, intercept and pop the LoginModal in
 * place (recording where to go after login). If they're already logged
 * in — even at a tier that won't pass the destination's gate — let them
 * navigate normally so they see the in-context upgrade/credit-burn UI on
 * the destination page.
 */
const GatedLink: React.FC<LinkProps> = ({ to, onClick, children, ...rest }) => {
  const { isAuthenticated, requestLogin } = useAuth();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!isAuthenticated) {
      e.preventDefault();
      const target = typeof to === 'string' ? to : (to as { pathname?: string }).pathname ?? null;
      requestLogin(target);
      return;
    }
    onClick?.(e);
  };

  return (
    <Link to={to} onClick={handleClick} {...rest}>
      {children}
    </Link>
  );
};

export default GatedLink;
